import { compose, hoistStatics, withState, withHandlers, withProps, defaultProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import ActiveButton from './ActiveButton';

const onClick = props => async () => {
  props.setIsUpdating(true);
  await props.onClickCallback();
  props.setIsUpdating(false);
};

const updatingIcon = 'fa fa-refresh fa-spin mr-1';

const enhance = compose(
  defaultProps({
    disabled: false,
    className: '',
    color: 'warning',
    icon: 'play',
    label: 'Click it',
    onClickCallback: () => {console.log('click active button')}
  }),
  withState('isUpdating', 'setIsUpdating', false),
  withProps(props => ({
    iconClass: props.isUpdating ? updatingIcon : `fa fa-${props.icon} mr-1`,
  })),
  withHandlers({
    onClick,
  }),
);

export default withRouter(hoistStatics(enhance)(ActiveButton));



// WEBPACK FOOTER //
// ./src/components/cms/activeButton/index.js